<template>
    <div>
        <fieldset>
            <button class="campaignButton" @click="createCampaign">Create a Campaign</button>
            <table>
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>Campaign name</th>
                        <th>Trial period (days)</th>
                        <th>Card required</th>
                        <th>Discount (%)</th>
                        <th>Discount (£)</th>
                        <th>Single use code</th>
                        <th>Campaign expiry date</th>
                        <th>Number of redemptions</th>
                        <th>Options</th>
                    </tr>
                </thead>
                <tbody v-if="campaigns === null">
                    <tr>
                        <td colspan="10" class="LoadingCell">
                            <loading-indicator /> Loading Campaign
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr v-for="(campaign, index) in campaigns" :key="campaign.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ campaign.campaignName }}</td>
                        <td class="alignCenter">{{ campaign.trialDays !== 0 && campaign.trialDays !== null ? campaign.trialDays : '-' }}</td>
                        <td>{{ campaign.isCardRequired }}</td>
                        <td class="alignCenter">{{ campaign.discount !== null && campaign.discount !== 0 ? campaign.discount : '-' }}</td>
                        <td class="alignCenter">{{ campaign.amountDiscount !== null && campaign.amountDiscount !== 0 ? campaign.amountDiscount : '-' }}</td>
                        <td>{{ campaign.isSingleUsed }}</td>
                        <td>{{ displayDate(campaign.expiredDate) }}</td>
                        <td class="alignCenter">{{ campaign.redemptions }}</td>
                        <td class="Options">
                            <button @click="openEditModal(campaign.id)">Edit</button>
                            <button v-if="campaign.id !== null" @click="viewCodes(campaign)">View Codes</button>
                            <button v-if="campaign.redemptions == 0" class="destructive" @click="deleteCampaign(campaign.id)">Delete</button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <campaign-codes v-if="IsCampaignCodesList"
                            :campaigncodes="campaignCodesList"
                            :selectedCampaign="selectedCampaignName"
                            :iscampaigncodeslist="IsCampaignCodesList"
                            @trial-codes-saved="updateCampaignCodes"
                            @close-modal="closeModal"
                            @campaignCodesUpdated="updateCampaignCodes" />
            <add-edit-campaign v-if="IsEditModalOpen" :campaignId="selectedCampaignId" @close-modal="closeEditModal" @campaign-id-updated="handleCampaignIdUpdated" />
        </fieldset>
    </div>
</template>

<style scoped>
    .campaignButton {
        margin-bottom: 10px;
        float: right !important;
    }

    .alignCenter {
        text-align: center;
    }
</style>

<script>
    import LoadingIndicator from './LoadingIndicator.vue';
    import CampaignCodes from './CampaignCodes.vue';
    import AddEditCampaign from './AddEditCampaign.vue';
    import $ from 'jquery';

    export default {
        name: 'Campaign',
        components: {
            LoadingIndicator,
            CampaignCodes,
            AddEditCampaign
        },
        data: function () {
            return {
                campaigns: null,
                campaignCodesList: null,
                selectedCampaignName: [],
                IsCampaignCodesList: false,
                IsEditModalOpen: false,
                selectedCampaignId: null,
            }
        },
        created: function () {
            this.getCampaignList();
        },
        methods: {
            updateCampaignCodes(newCodes) {
                this.campaignCodesList = newCodes;
            },
            closeModal() {
                this.IsCampaignCodesList = false;
                this.selectedCampaignName = [];
                this.getCampaignList();
            },
            openEditModal(campaignId) {
                this.selectedCampaignId = campaignId;
                this.IsEditModalOpen = true;
            },
            closeEditModal() {
                this.IsEditModalOpen = false;
                this.selectedCampaignId = null;
                this.getCampaignList();
            },
            setSelectedCampaignName(campaignName) {
                this.selectedCampaignName = campaignName;
            },
            getCampaignList: function () {
                var myComponent = this;
                myComponent.loading = true;
                $.ajax({
                    type: 'GET',
                    url: `/Campaign/GetCampaigns`,
                    dataType: 'json',
                    success: function (data) {
                        if (data !== null)
                            myComponent.campaigns = data;
                    },
                    complete: function () {
                        myComponent.loading = false;
                    },
                });
            },
            getCampaignCodeList: function (id) {
                var myComponent = this;
                myComponent.loading = true;
                $.ajax({
                    type: 'GET',
                    url: `/Campaign/GetCampaignCodes/${id}`,
                    dataType: 'json',
                    success: function (data) {
                        if (data !== null) {
                            myComponent.campaignCodesList = data;
                        } else {
                            myComponent.campaignCodesList = [];
                        }
                    },
                    complete: function () {
                        myComponent.loading = false;
                    },
                });
            },
            displayDate: function (d) {
                if (d === null)
                    return "-";
                return d.substr(8, 2) + "/" + d.substr(5, 2) + "/" + d.substr(0, 4);
            },
            viewCodes: function (campaign) {
                this.IsCampaignCodesList = true;
                this.setSelectedCampaignName(campaign);
                this.getCampaignCodeList(campaign.id);
            },
            createCampaign: function () {
                this.IsEditModalOpen = true;
                this.selectedCampaignId = null;
            },
            deleteCampaign(campaignId) {
                if (confirm("Are you sure you want to delete this campaign?")) {
                    $.ajax({
                        type: 'DELETE',
                        url: `/Campaign/DeleteCampaign/${campaignId}`,
                        success: () => {
                            this.getCampaignList();
                        },
                        error: (xhr, error) => {
                            if (xhr.status === 400) {
                                alert(xhr.responseText);
                            } else if (xhr.status === 404) {
                                alert("Campaign not found.");
                            } else if (xhr.status === 500) {
                                const responseText = xhr.responseText;
                                if (responseText.includes("You can not delete as campain is created in stripe")) {
                                    alert("You cannot delete this campaign because it has a Stripe coupon associated with it.");
                                } else {
                                    alert(responseText);
                                }
                            } else {
                                alert('Error deleting campaign:', error);
                            }
                        }
                    });
                }
            },
            handleCampaignIdUpdated(newCampaignId) {
                this.selectedCampaignId = newCampaignId;
            }
        },
    }
</script>